import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  custom: "dibcoygz4u",
  toggled: "dibtanacrq"
});
const wrapper = "dibwmnjp1z";
const content = "dibckooljz";
const input = "dibioqcaz0";

export { content, input, modifiers, wrapper };
import "./option.style.linaria.module.css";
//# sourceMappingURL=option.style.js.map
